<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="monitoringListBox">
            <van-nav-bar
                title="监控列表"
                left-arrow
                @click-left="onClickLeft"
            >
                <template #right>
                    <van-dropdown-menu>
                        <van-dropdown-item @change="changeSelect" v-model="stationId" :options="selectOption"></van-dropdown-item>
                    </van-dropdown-menu>
                </template>
            </van-nav-bar>
            <section>
                <div class="videoListBox">
                    <div v-for="(item, index) in videoGrouping" :key="index" :class="item.subShow ? 'bgBlue' : ''">
                        <h2 @click="getVideoSubclass(item, index)">
                            {{ item.group_name }}
                            <span v-if="videoSubclass" :class="item.subShow ? 'iconfont iconxiala1': 'iconfont iconxiala'"></span>
                        </h2>
                        <ul v-if="item.subShow">
                            <li v-for="(ite, idx) in item.subitemList" :key="idx" @click="toLookVideo(ite)">
                                <p>
                                    <span class="iconfont iconshipin"></span>
                                    {{ ite.device_id }} {{ ite.device_name }}
                                </p>
                                <van-icon name="arrow"></van-icon>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 视频监控
    name: 'monitoring-list',
    data() {
        return {
            tenantId: '',
            stationId: '',
            companyId: '',
            videoGrouping: [],
            videoSubclass: [],
            accordionData: [],
            stationList: [],
            setectValue: '',
            selectOption: [],
        };
    },
    mounted() {
        this.getStationList();
        this.tenantId = this.$takeTokenParameters('TenantId');
        this.companyId = this.$takeTokenParameters('CompanyId');
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 拉取场站列表
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationList.push(...stationList);
                this.selectOption = this.stationList.map(item => {
                    return {
                        text: item.name,
                        value: item.station_id,
                    };
                });
                this.stationId = this.stationList[0].station_id;
                this.generateNumber();
            }
        },
        // 获取视频分组
        generateNumber() {
            this.$axios
                .get(`/interfaceApi/tenant/tenant3d/videogroup/${this.tenantId}/${this.stationId}`)
                .then(res => {
                    this.videoGrouping = res;
                    this.videoGrouping.forEach(item => {
                        item.subShow = false;
                    });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        changeSelect() {
            this.generateNumber();
        },
        // 获取视频分组子类
        getVideoSubclass(item, idx) {
            this.$axios
                .get(`/interfaceApi/tenant/tenant3d/Videodevice/${this.tenantId}/${this.stationId}/${item.group_code}`)
                .then(res => {
                    this.videoSubclass = res;
                    this.videoGrouping[idx].subitemList = this.videoSubclass;
                    this.videoGrouping.forEach(item => {
                        // 判断如果数据中的menuList[i]的show属性不等于当前数据的isSubShow属性那么menuList[i]等于false
                        if (item.subShow !== this.videoGrouping[idx].subShow) {
                            item.subShow = false;
                        }
                    });
                    item.subShow = !item.subShow;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        toLookVideo(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/surveillance',
                query: {
                    videoLink: item.live_address,
                    id: item.device_id,
                    stationId: this.stationId,
                },
            });
        },
    },
};

</script>
<style lang='stylus'>
.monitoringListBox
    width 100%
    .van-dropdown-menu__bar
        height .42rem
    .van-dropdown-menu__item
        background #101077
        div
            color #fff
            margin-top 7rpx
        .van-dropdown-menu__title::after
            color #fff
            margin-top -2rpx
        .monitoringListBox .van-dropdown-menu__item .van-dropdown-menu__title::after
            margin-top -0rpx
    section
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .videoListBox
            height calc(100% - 45rpx)
            overflow scroll
            position: absolute;
            width: 100%;
            .bgBlue
                background #F9FBFE
            div
                display flex
                flex-direction column
                h2
                    font-weight normal
                    height 45rpx
                    border-bottom 1px solid #EFEFEF
                    display flex
                    align-items center
                    justify-content space-between
                    padding 0 15rpx
                    font-size 16rpx
                    span
                        font-size 20rpx
                        color #979DA7
                ul li
                    height 40rpx
                    border-bottom 1px solid #EFEFEF
                    display flex
                    align-items center
                    justify-content space-between
                    padding 0 15rpx
                    color #656565
                    font-size 14rpx
                    .van-icon
                        font-size 14rpx
                        color #ccc
                    p
                        display flex
                        align-items center
                        justify-content center
                        span
                            color #3395FB
                            font-size 26rpx
                            margin-right 5rpx
</style>
